/**
 * 3 Nov 2026 (D-1103-SIMPLE): "Simpler screens" — one Admin → Settings switch for the layout merges of the
 * overnight 1.9.1 build (fewer places to look). Read by the app from the Day plan settings every role already gets
 * (/api/dayplan carries every HK_ row).
 *
 *   HK_SIMPLER_SCREENS  Yes (default)  the merged layouts: Approve all (n) at the top of Planning, setting codes shown
 *                                      only while searching, the Volunteers list's service and affiliation filters
 *                                      under More filters.
 *   HK_SIMPLER_SCREENS  No             exactly the screens as they were before 1.9.1.
 *
 * Nothing a press does changes; every function stays reachable.
 */
export const SIMPLER_SCREENS_KEY = 'HK_SIMPLER_SCREENS';

type Settings = Record<string, string | undefined> | undefined | null;

/** On unless the row says No (a site with no row is on). */
export function simplerScreensOn(settings: Settings): boolean {
  return !/^(no|false|off|0)$/i.test(String(settings?.[SIMPLER_SCREENS_KEY] ?? '').trim());
}
